import { contains, drop, filter, head, join, pipe, prepend, split } from 'ramda';

export const AUTH_API_BASE_URL = process.env.REACT_APP_SS_AUTH_BASE_URL;
export const AUTH_API_KEY = process.env.REACT_APP_SS_AUTH_API_KEY;
export const USER_POOL_ID = process.env.REACT_APP_AMAZON_COGNITO_USER_POOL_ID;
export const CLIENT_ID = process.env.REACT_APP_AMAZON_COGNITO_CLIENT_ID;
export const OFFICIALS_CONNECT_CLIENT_ID = process.env.REACT_APP_OFFICIALS_CONNECT_CLIENT_ID;
export const SPORTS_CONNECT_CLIENT_ID = process.env.REACT_APP_SPORTS_CONNECT_CLIENT_ID || '';
const parseDomain = pipe(
  split('/'),
  filter(contains('.com')),
  head,
  split('.'),
  drop(1),
  prepend(''),
  join('.')
);
export const DOMAIN = contains('localhost', AUTH_API_BASE_URL || 'localhost')
  ? undefined
  : parseDomain(AUTH_API_BASE_URL);



// WEBPACK FOOTER //
// ./src/config/config.js